<template>
  <div class="list">
    <div class="item" v-for="(item,index) in queue" :key="index">
      <div class="filename"> {{item.file.name}}</div>
      <el-progress :percentage="parseInt(item.progress*100)" :color="'#67c23a'"></el-progress>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UploadProgress",
  data() {
    return {
      timer: "",
      queue: [],
    };
  },
  computed: {
    ...mapGetters(["complete"]),
  },
  watch: {
    complete(val) {
      if (val) {
        clearInterval(this.timer);
        this.queue = [];
      } else {
        this.timer = setInterval(this.monitor, 100);
      }
    },
  },
  methods: {
    monitor() {
      this.queue = Object.assign([], this.$store.state.oss.queue);
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  opacity: 0.8;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 400px;
  font-size: 12px;
  z-index: 5555;
  border-left: 1px solid #eaebf0;
  border-top: 1px solid #eaebf0;
  border-top-left-radius: 10px;
}
.item {
  background: #ffffff;
  padding: 10px;
  border-bottom: 1px solid #eaebf0;
}
.item:first-child {
  border-top-left-radius: 10px;
}
.item:last-child {
  border-bottom: 0;
}
</style>
